import {ExternalFileContentActions, ExternalFileContentActionsTypes} from './actions';

export interface ExternalFileContentState {
  init: boolean;
  isPreview: boolean;
  form: any;
  tmpForm: any | null;
}

export const initialExternalFileContentState: ExternalFileContentState = {
  init: false,
  form: {
    url: '',
  },
  isPreview: false,
  tmpForm: {},
}

export default function ExternalFileContentReducer(
  state: ExternalFileContentState = initialExternalFileContentState,
  action: ExternalFileContentActions
): ExternalFileContentState {

  switch (action.type) {
    case ExternalFileContentActionsTypes.SET_INIT:
      return {
        ...state,
        init: action.payload,
      }
    case ExternalFileContentActionsTypes.SET_EXTERNAL_FILE_FORM:
      return {
        ...state,
        form: action.payload,
        init: true,
      }
    case ExternalFileContentActionsTypes.SET_EXTERNAL_FILE_FORM_KEY_VALUE:
      return {
        ...state,
        form: {
          ...state.form || {},
          [action.payload.key]: action.payload.value,
        },
      }
    case ExternalFileContentActionsTypes.SET_EXTERNAL_FILE_FORM_KEYS_VALUES:
      return {
        ...state,
        form: {
          ...state.form || {},
          ...action.payload,
        }
      }
    case ExternalFileContentActionsTypes.SET_PREVIEW:
      return {
        ...state,
        isPreview: true,
        form: {
          ...state.form,
          ...action.payload,
        },
        tmpForm: state.form,
      }
    case ExternalFileContentActionsTypes.UNSET_PREVIEW:
      return {
        ...state,
        form: state.tmpForm,
        tmpForm: null,
        isPreview: false,
      }
    default:
      return state;
  }
};
